import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { Menu, MenuItem } from '@material-ui/core'
import classNames from 'classnames'
import { useLocalStore, useObserver } from 'mobx-react-lite'
import React from 'react'
import styled, { css } from 'styled-components'
import * as style from './ListViewDropDown.css'

interface IListViewDropDown {
  values?: any
  borderColor?: string
  label?: string
  disabled?: boolean
  onChange?: any
}

interface IStyledDiv {
  border?: string
}

const StyledStatusDiv = styled.div`
  ${(props: IStyledDiv) => css`
    border-bottom: ${'2px solid' + props.border};
  `}
`

export const ListViewDropDown: React.FunctionComponent<IListViewDropDown> = React.memo(
  ({ values, label, onChange, borderColor, disabled }) => {
    const state = useLocalStore(() => ({
      anchorEl: null,
      onMenuClose: () => {
        state.anchorEl = null
      },
      onMenuClick: event => {
        state.anchorEl = event.currentTarget
      },
      onMenuItemClick: event => {
        state.anchorEl = null
        onChange(event)
      }
    }))
    return useObserver(function useHook() {
      return (
        <div className={style.menuContainer}>
          <div onClick={state.onMenuClick} className={style.dropdownWrapper}>
            <StyledStatusDiv border={borderColor}>
              <span
                className={classNames({
                  [style.titleContainer]: true,
                  [style.disabled]: disabled
                })}
              >
                {label}
              </span>
            </StyledStatusDiv>
            {disabled ||
              (values && values.length > 0 && (
                <div
                  className={classNames(style.menuArrow, {
                    [style.openMenu]: Boolean(state.anchorEl)
                  })}
                >
                  <ArrowDropDownIcon
                    className={style.headerIconSize}
                    classes={{
                      fontSizeLarge: style.headerIconSize
                    }}
                  />
                </div>
              ))}
          </div>
          {disabled ||
            (values && values.length > 0 && (
              <Menu
                id='list-menu'
                anchorEl={state.anchorEl}
                open={Boolean(state.anchorEl)}
                onClose={state.onMenuClose}
                onChange={event => onChange(event)}
                classes={{ paper: style.paperMenu }}
                MenuListProps={{ classes: { root: style.list } }}
              >
                {values.map((menu, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={menu.value}
                      className={classNames(style.item)}
                      onClick={state.onMenuItemClick}
                    >
                      {menu.label}
                    </MenuItem>
                  )
                })}
              </Menu>
            ))}
        </div>
      )
    })
  }
)
